export default "__VITE_ASSET__CL6U7FXt__"